import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '../views/Home.vue';
import Form from '../views/Form';
import SignupLanding from '../views/SignupLanding.vue';
import Signup from "../views/Signup.vue";
import Activate from "../views/Activate.vue";
import Profile from "../views/Profile.vue";
import SignupSuccess from "../views/SignupSuccess.vue";
import Signin from "../views/Signin.vue";
import ThankYou from '../views/ThankYou.vue'
import auth from "../auth";
Vue.use(VueRouter);

function requireAuth(to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: "/signin",
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

const routes = [
  {
    path: '/signup',
    name: 'signup',
    component: Signup,
  },
  {
    path: '/signupsuccess',
    name: 'signupsuccess',
    component: SignupSuccess,
  },
  {
    path: '/signin',
    name: 'signin',
    component: Signin,
  },
  {
    path: '/activate/:hash',
    name: 'activate',
    props:true,
    component: Activate,
  },
  {
    path: '/enterdetails',
    name: 'enterdetails',
    beforeEnter: requireAuth,
    component: Form,
  },
  {
    path: '/profile',
    name: 'profile',
    beforeEnter: requireAuth,
    component: Profile,
  },
  {
    path: '/',
    name: 'home',
    component: SignupLanding,
  },

  {
    path: '/success',
    name: 'success',
    component: ThankYou,
  },
  {
    path: "/logout",
    name: "Logout",
    beforeEnter(to, from, next) {
      auth.logout();
      next("/");
    }
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
